/**
 * API 진입점 — 모드에 따라 목/HTTP 어댑터를 고른다.
 *
 *   import api from '../api';
 *   const { token, user } = await api.auth.login({ email, password });
 *
 * 화면 코드는 어댑터가 무엇인지 몰라야 한다.
 */
import { IS_MOCK } from '../config/env';
import mockApi, { setMockToken } from './mockApi';
import httpApi, { configureHttp } from './httpApi';

const api = IS_MOCK ? mockApi : httpApi;

/** 인증 스토어가 부팅 시 한 번 호출한다. */
export function bindAuth({ getToken, unauthorized }) {
  if (IS_MOCK) {
    setMockToken(getToken());
  } else {
    configureHttp({ getToken, unauthorized });
  }
}

/** 토큰이 바뀔 때(로그인/로그아웃) 어댑터에 알린다. */
export function syncToken(token) {
  if (IS_MOCK) setMockToken(token);
}

export { ApiError, errorMessage } from './errors';
export default api;
